// extracted by mini-css-extract-plugin
module.exports = {"initiativesList":"InitiativesList_initiativesList__3ueOF","content":"InitiativesList_content__1sT-U"};